// extracted by mini-css-extract-plugin
export default {"heading":"Header_heading__rdQ4k"};